export default __webpack_public_path__ + "static/media/ArrowUp.12090310.svg";